export const BANK_INFO = {
  bank: "BBVA México",
  clabe: "012770011161566570",
  card: "4152 3146 4391 4446",
  beneficiary: "CrisAngel",
  whatsapp: "+52 662 287 0805",
  whatsappLink: "https://wa.me/526622870805",
  tiktok: "https://www.tiktok.com/@crisangelastral",
  tiktokHandle: "@crisangelastral",
  // PayPal — visible to all logged-in users (MX + INTL)
  paypalEmail: "datoconfirmadonoticias@gmail.com",
  // BBVA account for international clients (uses full legal name)
  internationalBank: {
    bank: "BBVA México",
    clabe: "012770011161566570",
    card: "4152 3146 4391 4446",
    beneficiary: "CrisAngel Astral Rodriguez Jaime",
    whatsapp: "+52 662 287 0805",
  },
  // For clients outside Mexico
  internationalRemittance: {
    platforms: ["Remitly", "Wise", "Xoom", "Ria Money Transfer", "Western Union", "MoneyGram"],
    pickupChain: "Soriana",
    pickupName: "CrisAngel Astral Rodriguez Jaime",
    pickupState: "Guaymas, Sonora, México",
    pickupPhone: "+52 662 287 0805",
  },
};

// Services data (bilingual)
export const SERVICES = [
  // ====== LECTURAS ======
  {
    id: "lectura_basica",
    category: "lectura",
    name: { es: "Lectura Básica", en: "Basic Reading" },
    subtitle: { es: "Llamada", en: "Phone Call" },
    duration: { es: "Hasta 20 minutos", en: "Up to 20 minutes" },
    priceMXN: 1700,
    priceUSD: 100,
    modalities: [
      {
        id: "llamada",
        label: { es: "Llamada", en: "Phone Call" },
        priceMXN: 1700,
        priceUSD: 100,
      },
    ],
    badge: null,
    features: {
      es: ["Baraja Española", "Tarot", "Atención el mismo día o al siguiente"],
      en: ["Spanish Deck", "Tarot", "Same day or next day attention"],
    },
    description: {
      es: "Una lectura íntima por llamada para resolver tus inquietudes con la energía de las cartas.",
      en: "An intimate phone reading to resolve your concerns through the energy of the cards.",
    },
  },
  {
    id: "lectura_completa",
    category: "lectura",
    name: { es: "Lectura Completa con Runas", en: "Complete Reading with Runes" },
    subtitle: { es: "Llamada o Videollamada", en: "Phone Call or Video Call" },
    duration: { es: "Hasta 1 hora", en: "Up to 1 hour" },
    priceMXN: 2600,
    priceUSD: 150,
    modalities: [
      {
        id: "llamada",
        label: { es: "Llamada", en: "Phone Call" },
        priceMXN: 2600,
        priceUSD: 150,
      },
      {
        id: "videollamada",
        label: { es: "Videollamada", en: "Video Call" },
        priceMXN: 3600,
        priceUSD: 200,
      },
    ],
    badge: null,
    features: {
      es: [
        "Runas",
        "Baraja Española",
        "Tarot",
        "Lectura adicional",
        "Predicciones",
        "Respuesta a preguntas durante la sesión",
      ],
      en: [
        "Runes",
        "Spanish Deck",
        "Tarot",
        "Additional reading",
        "Predictions",
        "Questions answered during the session",
      ],
    },
    description: {
      es: "Inmersión profunda en tu energía con runas nórdicas y todas las cartas. Respuestas claras y predicciones precisas.",
      en: "Deep immersion in your energy with Nordic runes and all the cards. Clear answers and precise predictions.",
    },
  },
  {
    id: "lectura_completa_video",
    category: "lectura",
    name: { es: "Lectura Completa por Videollamada", en: "Complete Reading via Video Call" },
    subtitle: { es: "Videollamada · Runas + Tarot", en: "Video Call · Runes + Tarot" },
    duration: { es: "Hasta 1 hora", en: "Up to 1 hour" },
    priceMXN: 3500,
    priceUSD: 200,
    modalities: [
      {
        id: "videollamada",
        label: { es: "Videollamada", en: "Video Call" },
        priceMXN: 3500,
        priceUSD: 200,
      },
    ],
    badge: { es: "PREMIUM", en: "PREMIUM" },
    features: {
      es: [
        "Todo lo de la Lectura Completa por llamada",
        "Contacto visual en tiempo real con CrisAngel",
        "Ves físicamente las cartas y runas mientras se colocan",
        "Interpretación visual de tu energía y aura",
        "Sensación de sesión presencial desde donde estés",
        "Grabación opcional de la lectura para que la revises",
        "Bendición energética con las cartas expuestas a cámara",
        "Preguntas ilimitadas durante la videollamada",
      ],
      en: [
        "Everything from the Complete Reading by phone",
        "Real-time eye contact with CrisAngel",
        "Watch the cards and runes being laid out",
        "Visual reading of your energy and aura",
        "In-person feel from wherever you are",
        "Optional recording of the session for review",
        "Energetic blessing with cards on camera",
        "Unlimited questions during the video call",
      ],
    },
    description: {
      es: "La experiencia más completa: te veo a los ojos mientras leo tus cartas y runas. Ideal si buscas la conexión y precisión de una sesión presencial sin salir de casa.",
      en: "The most complete experience: I see you eye-to-eye while I read your cards and runes. Ideal if you want the connection and accuracy of an in-person session without leaving home.",
    },
  },
  {
    id: "vidente_virtual",
    category: "lectura",
    // Oculto del catálogo público — sigue disponible para uso interno
    // (admin: gestión de planes existentes, dossier de usuarios, etc.).
    hidden: true,
    name: { es: "Lectura en Línea (Vidente Virtual)", en: "Online Reading (Virtual Vidente)" },
    subtitle: { es: "IA de CrisAngel Astral · Voz en vivo 24/7", en: "Cristopher AI · Live Voice 24/7" },
    duration: { es: "Acceso por tiempo", en: "Time-based access" },
    priceMXN: 3500,
    priceUSD: 200,
    modalities: [
      { id: "24h",   label: { es: "Acceso 24 horas", en: "24-hour access" }, priceMXN: 3500,  priceUSD: 200 },
      { id: "1mes",  label: { es: "Acceso 1 mes",   en: "1-month access" }, priceMXN: 18000, priceUSD: 1000 },
      { id: "1ano",  label: { es: "Acceso 1 año",   en: "1-year access" },  priceMXN: 43000, priceUSD: 2500 },
    ],
    badge: { es: "Nuevo", en: "New" },
    features: {
      es: [
        "Conversación por voz en tiempo real con CrisAngel Astral",
        "Respuestas más rápidas — casi al instante",
        "Memoria espiritual entre cada consulta",
        "Tirada de cartas (Tarot, Baraja Española, Runas)",
        "Voz mística cinematográfica",
        "Disponible 24/7 sin agendar cita",
        "Privado y seguro — solo tú y el maestro Cristopher",
      ],
      en: [
        "Real-time voice conversation with Cristopher",
        "Faster responses — nearly instant",
        "Spiritual memory across every session",
        "Card readings (Tarot, Spanish Deck, Runes)",
        "Cinematic mystical voice",
        "Available 24/7 without booking",
        "Private and secure — only you and the master Cristopher",
      ],
    },
    description: {
      es: "El don de CrisAngel Astral, disponible al instante. Consulta espiritual real por voz, con memoria activa que recuerda tu historia entre sesiones. Habla cuando el corazón te lo pida.",
      en: "Cristopher's gift, available instantly. Real spiritual voice consultation with active memory that remembers your history across sessions. Speak whenever your heart asks.",
    },
  },

  // ====== HECHICERÍA ======
  {
    id: "magia_blanca",
    category: "hechiceria",
    name: { es: "Magia Blanca", en: "White Magic" },
    subtitle: { es: "Trabajo de luz", en: "Light Work" },
    duration: { es: "Resultados < 90 días", en: "Results < 90 days" },
    priceMXN: 6900,
    priceUSD: 400,
    badge: null,
    features: {
      es: [
        "Resultados aproximados: < 90 días",
        "Efecto temporal (media escala)",
        "Duración del efecto: 1 año",
        "Incluye Lectura Completa gratis",
      ],
      en: [
        "Approximate results: < 90 days",
        "Temporary effect (medium scale)",
        "Effect duration: 1 year",
        "Includes free Complete Reading",
      ],
    },
    description: {
      es: "Trabajo espiritual de magia blanca para atraer luz, amor, dinero o protección de forma sutil y prolongada.",
      en: "White magic spiritual work to attract light, love, money or protection in a subtle and lasting way.",
    },
  },
  {
    id: "magia_negra",
    category: "hechiceria",
    name: { es: "Magia Negra + Protección Blanca", en: "Black Magic + White Protection" },
    subtitle: { es: "Trabajo intenso", en: "Intense Work" },
    duration: { es: "Resultados < 60 días", en: "Results < 60 days" },
    priceMXN: 13900,
    priceUSD: 800,
    badge: null,
    features: {
      es: [
        "Resultados aproximados: < 60 días",
        "Efecto temporal (media escala)",
        "Duración del efecto: 5 años",
        "Protección blanca incluida",
        "Incluye Lectura Completa gratis",
      ],
      en: [
        "Approximate results: < 60 days",
        "Temporary effect (medium scale)",
        "Effect duration: 5 years",
        "White protection included",
        "Includes free Complete Reading",
      ],
    },
    description: {
      es: "Magia oscura potente con escudo de protección blanca para resultados profundos sin retornos negativos.",
      en: "Powerful dark magic with white protection shield for deep results without negative returns.",
    },
  },
  {
    id: "magia_suprema",
    category: "hechiceria",
    name: { es: "Magia Suprema", en: "Supreme Magic" },
    subtitle: { es: "Incluye todas las magias", en: "Includes all magics" },
    duration: { es: "Resultados < 30 días", en: "Results < 30 days" },
    priceMXN: 26000,
    priceUSD: 1500,
    badge: { es: "RECOMENDADO", en: "RECOMMENDED" },
    features: {
      es: [
        "Resultados aproximados: < 30 días",
        "Efecto permanente (alta escala)",
        "Combina todas las magias",
        "Incluye Lectura Completa gratis",
      ],
      en: [
        "Approximate results: < 30 days",
        "Permanent effect (high scale)",
        "Combines all magics",
        "Includes free Complete Reading",
      ],
    },
    description: {
      es: "Fusión completa de magias blanca, negra y suprema. Resultados permanentes y de alta escala.",
      en: "Complete fusion of white, black and supreme magic. Permanent and high-scale results.",
    },
  },
  {
    id: "poder_maximo",
    category: "hechiceria",
    name: { es: "Poder Máximo", en: "Maximum Power" },
    subtitle: { es: "Todos los servicios incluidos", en: "All services included" },
    duration: { es: "Resultados < 7 días", en: "Results < 7 days" },
    priceMXN: 43000,
    priceUSD: 2500,
    badge: { es: "ÉLITE", en: "ELITE" },
    features: {
      es: [
        "Resultados aproximados: < 7 días",
        "Efecto permanente (máxima escala)",
        "Trabajo heredable",
        "Todos los servicios incluidos",
        "Incluye Lectura Completa gratis",
      ],
      en: [
        "Approximate results: < 7 days",
        "Permanent effect (maximum scale)",
        "Heritable work",
        "All services included",
        "Includes free Complete Reading",
      ],
    },
    description: {
      es: "El trabajo más poderoso. Resultados rápidos, permanentes y heredables para tu linaje.",
      en: "The most powerful work. Fast, permanent and heritable results for your lineage.",
    },
  },
  {
    id: "pacto_luz",
    category: "pacto",
    name: { es: "Pacto de Luz (Seguro)", en: "Light Pact (Safe)" },
    subtitle: { es: "Conexión espiritual y desarrollo personal", en: "Spiritual connection & personal growth" },
    duration: { es: "Efecto permanente", en: "Permanent effect" },
    priceMXN: 87000,
    priceUSD: 5000,
    badge: { es: "PACTO ESPIRITUAL", en: "SPIRITUAL PACT" },
    features: {
      es: ["Fortalece conexión espiritual", "Protección energética profunda", "Desarrollo personal acelerado"],
      en: ["Strengthens spiritual connection", "Deep energetic protection", "Accelerated personal growth"],
    },
    description: {
      es: "Pacto seguro de luz que sella tu camino espiritual con protección permanente.",
      en: "A safe pact of light that seals your spiritual path with permanent protection.",
    },
  },
  {
    id: "pacto_satanico",
    category: "pacto",
    name: { es: "Pacto Satánico (Seguro)", en: "Satanic Pact (Safe)" },
    subtitle: { es: "El pacto más extremo y poderoso", en: "The most extreme and powerful pact" },
    duration: { es: "Resultados desde el día siguiente", en: "Results from the next day" },
    priceMXN: 173000,
    priceUSD: 10000,
    badge: { es: "MÁXIMO PODER", en: "ULTIMATE" },
    features: {
      es: [
        "Resultados a partir del día siguiente",
        "Efecto permanente y sin karma",
        "Protección absoluta",
        "Incluye Lectura Completa gratis",
      ],
      en: [
        "Results starting next day",
        "Permanent effect, no karma",
        "Absolute protection",
        "Includes free Complete Reading",
      ],
    },
    description: {
      es: "El nivel más alto del arte oscuro. Resultados casi inmediatos con protección absoluta y sin retorno kármico.",
      en: "The highest level of the dark art. Almost immediate results with absolute protection and no karmic return.",
    },
  },
];

export const HECHICERIA_TOPICS = {
  es: [
    { icon: "Heart", label: "Amor" },
    { icon: "Coins", label: "Dinero" },
    { icon: "Shield", label: "Protección" },
    { icon: "Scale", label: "Justicia" },
    { icon: "Briefcase", label: "Trabajo y Negocios" },
    { icon: "Flame", label: "Rompimiento de Brujerías" },
    { icon: "Zap", label: "Poder Espiritual" },
    { icon: "Skull", label: "Venganzas" },
  ],
  en: [
    { icon: "Heart", label: "Love" },
    { icon: "Coins", label: "Money" },
    { icon: "Shield", label: "Protection" },
    { icon: "Scale", label: "Justice" },
    { icon: "Briefcase", label: "Work & Business" },
    { icon: "Flame", label: "Breaking Curses" },
    { icon: "Zap", label: "Spiritual Power" },
    { icon: "Skull", label: "Revenge" },
  ],
};
